import React from "react";
import {Helmet} from "react-helmet-async";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {Container} from "react-bootstrap";
import WatchdogTableHandler from "../../components/service/WatchdogTableHandler";


const WatchdogPage = () => (
    <React.Fragment>
        <Helmet title="Watchdog"/>
        <Container fluid className="p-0">
            <WatchdogTableHandler/>
        </Container>
    </React.Fragment>
);

export default WatchdogPage;
